import Repository from '../../../Repository';

const resource = '/kitsilano/orders';

export default {
  updateOrder(region, orderId, payload) {
    return Repository.put(`${resource}/${orderId}`, {
      region,
      ...payload
    });
  },
};
